import { useState } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Delete, Edit, Visibility } from "@mui/icons-material";

import { RootState } from "../../../redux/store";
import RoutingList from "../../../utils/RoutingList";
import { userRoles, userStatus } from "../../../constants/user";
import ConfirmationModal from "../../common/modal/confirmationModal/ConfirmationModal";

import { patientSx } from "./styles";
import styles from "./styles.module.scss"

type Props = {
  item: any;
  handleView: (id: string) => void;
  handleDelete: (id: string) => void;
};

const PatientTableActionIcons = ({ item, handleView, handleDelete }: Props) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const navigate = useNavigate();

  const { role } = useSelector(
    (state: RootState) => state?.auth?.profileData?.user,
    shallowEqual
  );

  const openConfirmationModal = () => {
    setShowConfirmationModal(true);
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const viewHandler = () => {
    handleView(item._id);
  };

  const editHandler = () => {
    navigate(`${RoutingList.patientAdmission.edit}/${item._id}`);
  };

  const deleteHandler = async () => {
    await handleDelete(item._id);
    setShowConfirmationModal(false);
  };

  return (
    <>
      <Box sx={patientSx.actionSx}>
        <Button sx={patientSx.iconBtn} type="button" onClick={viewHandler}>
          <Visibility sx={patientSx.colorGray} />
        </Button>
        {[userRoles?.SUPER_ADMIN, userRoles?.SURGEON].includes(role) && (
          <Button
            type="button"
            sx={patientSx.iconBtn}
            className={styles.editButton}
            disabled={![userStatus.DRAFTED, userStatus.QUERY_RAISED].includes(item.status)}
            onClick={editHandler}
          >
            <Edit sx={patientSx.colorGray} />
          </Button>
        )}
        {[userRoles?.SUPER_ADMIN].includes(role) && (
          <Button
            type="button"
            sx={patientSx.iconBtn}
            onClick={openConfirmationModal}
          >
            <Delete sx={patientSx.colorGray} />
          </Button>
        )}
      </Box>
      <ConfirmationModal
        submitText={"Delete"}
        open={showConfirmationModal}
        onConfirm={deleteHandler}
        onClose={closeConfirmationModal}
        description="Are you sure to delete this? You can not revert the changes."
      />
    </>
  );
};

export default PatientTableActionIcons;
